<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="5" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">品牌说明</b-th>
          <b-th colspan="3" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">单包装规格</b-th>
          <b-th colspan="2" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">指导用药量</b-th>
          <b-th colspan="4" style="text-align: center">实际总药量</b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(itemName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.itemName)">{{ data.item.itemName }}</div>
      </template>

<!--      <template v-slot:cell(quantity)="data">-->
<!--        {{ Number(data.item.quantity).toFixed(2) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(returnQuantity)="data">-->
<!--        {{ Number(data.item.returnQuantity).toFixed(2) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(unitPrice)="data">-->
<!--        {{ Number(data.item.unitPrice).toFixed(2) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(amount)="data">-->
<!--        {{ Number(data.item.amount).toFixed(2) }}-->
<!--      </template>-->


      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ApmsRegPlantProtectionInfoDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'materialCode', label: '物料编码', width: '120px'},
        {key: 'materialType2Name', label: '药剂种类', width: '120px'},
        {key: 'materialName', label: '化学名', width: '120px'},
        {key: 'productName', label: '商品名', width: '120px'},
        {key: 'trademark', label: '商标', width: '120px'},
        {key: 'manufacturer', label: '生产商', width: '120px'},
        {key: 'originPlace', label: '产地', width: '120px'},
        {key: 'refMaterialModel', label: '有效成分含量', width: '120px'},
        {key: 'dosageFormLabel', label: '剂型', width: '120px'},
        {key: 'purpose', label: '用途', width: '120px'},
        {key: 'netContent', label: '净含量', width: '120px'},
        {key: 'netContentUnitLabel', label: '单位', width: '120px'},
        {key: 'packageTypeLabel', label: '包装', width: '120px'},
        {key: 'shelfLife', label: '保质期', width: '120px'},
        {key: 'dilutionRatio', label: '稀释比例(倍)', width: '120px'},
        {key: 'guideDosageTotal', label: '净含量', width: '120px'},
        {key: 'netContentUnitLabel', label: '单位', width: '120px'},
        {key: 'actualDosage', label: '用量', width: '120px'},
        {key: 'netContentUnitLabel', label: '单位', width: '120px'},
        {key: 'actualQuantity', label: '数量', width: '120px'},
        {key: 'packageTypeLabel', label: '包装', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
